import __C from '../../primitives/_constant_'

const URL_HEADER = `${__C.HOST_NAME_API}/v0`
const WEBSOCKET_HEADER = `${__C.WEBSOCKET_API}/v0/ws`
const Url = {
  system: {
    config: {
      query2json  : `${URL_HEADER}/sysconfig/query2json`,
      codegroup   : `${URL_HEADER}/sysconfig/codegroup`,
      codeindex   : `${URL_HEADER}/sysconfig/codeindex`,
      navRelated  : `${URL_HEADER}/sysconfig/navRelated`,
      dbTransfer  : `${URL_HEADER}/sysconfig/dbTransfer`,
      phaseTrans  : `${URL_HEADER}/sysconfig/phaseTrans`,
      groupTrans  : `${URL_HEADER}/sysconfig/groupTrans`,
      subitemTrans: `${URL_HEADER}/sysconfig/subitemTrans`,
      navphase    : `${URL_HEADER}/sysconfig/navphase`,
      navgroup    : `${URL_HEADER}/sysconfig/navgroup`,
      navitem     : `${URL_HEADER}/sysconfig/navitem`,
      navsubitem  : `${URL_HEADER}/sysconfig/navsubitem`,
      subitemmenu : `${URL_HEADER}/sysconfig/subitem/menu`,
      origin      : `${URL_HEADER}/sysconfig/origin`,
      devUp      : `${URL_HEADER}/sysconfig/devUp`,
      catmenu: {
        chart   : `${URL_HEADER}/sysconfig/catmenu/chart`,
        numChild: `${URL_HEADER}/sysconfig/catmenu/numChild`
      },
      wbutton       : `${URL_HEADER}/sysconfig/wbutton`,
      iconRelated   : `${URL_HEADER}/sysconfig/iconRelated`,
      icons         : `${URL_HEADER}/sysconfig/icons`,
      iconsUpload   : `${URL_HEADER}/sysconfig/icons/upload`,
      chart         : `${URL_HEADER}/sysconfig/chart`,
      charts        : `${URL_HEADER}/sysconfig/charts`,
      chartsUpload  : `${URL_HEADER}/sysconfig/charts/upload`,
      setpriorities : `${URL_HEADER}/sysconfig/setpriorities`,
      chartlib: {
        list        : `${URL_HEADER}/chartlib/list`,
        thumbs      : `${URL_HEADER}/chartlib/thumbs`,
        donut       : `${URL_HEADER}/chartlib/donut`,
        pie         : `${URL_HEADER}/chartlib/pie`,
        barsolid    : `${URL_HEADER}/chartlib/barsolid`,
        barnormal   : `${URL_HEADER}/chartlib/barnormal`,
        barprogress : `${URL_HEADER}/chartlib/barprogress`,
        bardelta    : `${URL_HEADER}/chartlib/bardelta`,
        radar       : `${URL_HEADER}/chartlib/radar`,
        histogram   : `${URL_HEADER}/chartlib/histogram`,
        skyline     : `${URL_HEADER}/chartlib/skyline`,
        tsummary    : `${URL_HEADER}/chartlib/tsummary`,
        custom      : `${URL_HEADER}/chartlib/custom`,
        validateq   : `${URL_HEADER}/chartlib/validateq`,
      },
      pagecomp: {
        idx         : `${URL_HEADER}/page/idx`,
        dashadmin   : `${URL_HEADER}/page/dashadmin`,
        intdg       : `${URL_HEADER}/page/intdg`,
        previewdl   : `${URL_HEADER}/page/previewdl`,
        svgprops    : `${URL_HEADER}/page/svgprops`,
        rowsperpage : `${URL_HEADER}/page/rowsperpage`
      },
      database: {
        sqlquery: `${URL_HEADER}/database/sqlquery`,
        sqlexec : `${URL_HEADER}/database/sqlexec`
      },
      icon: `${URL_HEADER}/sysconfig/icon`,
      uploadList : `${URL_HEADER}/sysconfig/upload`,
    },
    code: {
      chartoptions    : `${URL_HEADER}/code/chartoptions`,
      datatableoptions: `${URL_HEADER}/code/dtoptions`,
      dashboardoptions: `${URL_HEADER}/code/dashoptions`,
      companies       : `${URL_HEADER}/code/companies`,
      compusers       : `${URL_HEADER}/code/compusers`,
      department      : `${URL_HEADER}/code/dept`,
      galleryoptions  : `${URL_HEADER}/code/galoptions`,
      position        : `${URL_HEADER}/code/position`,
      subitemphase    : `${URL_HEADER}/code/subitemphase`,
      subitemgroup    : `${URL_HEADER}/code/subitemgroup`,
      subitemitem     : `${URL_HEADER}/code/subitemitem`,
      sys: {
        columns   : `${URL_HEADER}/code/sys/columns`,
        columnsq  : `${URL_HEADER}/code/sys/columnsq`,
        tables    : `${URL_HEADER}/code/sys/tables`,
        databases : `${URL_HEADER}/code/sys/databases`
      }
    },
    values: {
      columns   : `${URL_HEADER}/sysvalues/columns`,
      tables    : `${URL_HEADER}/sysvalues/tables`,
      databases : `${URL_HEADER}/sysvalues/databases`
    },
    layout: {
      navigation: {
        menu: ''
      }
    },
    filebrowser: {
      resources: `${URL_HEADER}/filebrowser/resources`,
      raw: `${URL_HEADER}/filebrowser/raw`
    },
    service: {
      workorder  : `${URL_HEADER}/syssrv/workorder`,
      workorders : `${URL_HEADER}/syssrv/workorders`,
      wofile  : `${URL_HEADER}/syssrv/wofile`,
    }
  },
  service: {
    control: {
      putUpItems  : `${URL_HEADER}/svccontrol/putUpItems`,
      editUpItems  : `${URL_HEADER}/svccontrol/editUpItems`,
      delUpItems  : `${URL_HEADER}/svccontrol/delUpItems`,
      updateItems  : `${URL_HEADER}/svccontrol/updateItems`,
      member  : `${URL_HEADER}/svccontrol/member`,
      memberAdmin  : `${URL_HEADER}/svccontrol/memberAdmin`,
      bpmembers  : `${URL_HEADER}/svccontrol/bpmembers`,
      members : `${URL_HEADER}/svccontrol/members`,
    }
  },
  application: {
    construction: {
      moduleprogs: `${URL_HEADER}/construction/moduleprogs`
    },
    account: {
      signin: `${URL_HEADER}/auth/signin`,
      reqhist: `${URL_HEADER}/app/acct/reqhist`,
      reqmember: `${URL_HEADER}/auth/request`,
      uniqMember: `${URL_HEADER}/auth/uniq`,
      forgotMember: `${URL_HEADER}/auth/forgot`,
    },
    board: {
      reports: `${URL_HEADER}/app/board/reports`,
      report: `${URL_HEADER}/app/board/report`,
      file: `${URL_HEADER}/app/board/file`,
      export: `${URL_HEADER}/app/board/export`,
      datasource: `${URL_HEADER}/app/board/datasource`,
      uploadDS: `${URL_HEADER}/app/board/uploadDS`,
      originUpload: `${URL_HEADER}/app/board/originUpload`,      
      devUpload: `${URL_HEADER}/app/board/devUpload`,
      tortueUpload: `${URL_HEADER}/app/board/tortueUpload`,
      getFolder: `${URL_HEADER}/app/board/getFolder`,
      gdrive: `${URL_HEADER}/app/board/gdrive`,
      getColumns: `${URL_HEADER}/app/board/getColumns`,
      updateColumns: `${URL_HEADER}/app/board/updateColumns`,
      editColumns: `${URL_HEADER}/app/board/editColumns`,
      delColumns: `${URL_HEADER}/app/board/delColumns`,
      getTables: `${URL_HEADER}/app/board/getTables`,
      updateTables: `${URL_HEADER}/app/board/updateTables`,
      editTables: `${URL_HEADER}/app/board/editTables`,
      delFolder: `${URL_HEADER}/app/board/delFolder`,      
      delTables: `${URL_HEADER}/app/board/delTables`,
      createSource: `${URL_HEADER}/app/board/createSource`,
      setColumnScope: `${URL_HEADER}/app/board/setColumnScope`,
    },
    config: {
      routes: `${URL_HEADER}/aconf/routes`
    },
    layout: {
      navigation: {
        menu: `${URL_HEADER}/app/nav/menu`
      }
    },
    create:  {
      export: `${URL_HEADER}/app/create/export`
    },
    idgservice: {
      init        : `${URL_HEADER}/app/idgservice/init`,
      patronage   : `${URL_HEADER}/app/idgservice/patronage`,
      chainoptions: `${URL_HEADER}/app/idgservice/chainoptions`
    },
    dashboard: {
      get     : `${URL_HEADER}/app/dashboard/get`,
      contqres: `${URL_HEADER}/app/dashboard/contqres`,   // contqres: Container Query Result
    },
    tabs: {
      check   : `${URL_HEADER}/app/pagesvg/tabs`
    },
    pagesvg: {
      get: `${URL_HEADER}/app/pagesvg/get`,
    },
    chart: {
      dntValues: `${URL_HEADER}/app/chart/dntValues`
    },
    reqhist: {
      overview: `${URL_HEADER}/app/reqhist/overview`
    }
  },
  communicate: {
    comments: `${URL_HEADER}/communicate/comments`,
    comment: `${URL_HEADER}/communicate/comment`,
  },
  notice: {
    message: {
      membersunread: `${URL_HEADER}/notice/message/members/unread`,
      members: `${URL_HEADER}/notice/message/members`,
      onchat: {
        members: `${URL_HEADER}/notice/message/onchat/members`,
      },
      notices: `${URL_HEADER}/notice/message/notices`,
      onchats: `${URL_HEADER}/notice/message/onchats`,
      one2one: `${URL_HEADER}/notice/message/one2one`,
      group: `${URL_HEADER}/notice/message/group`,
      unreads: `${URL_HEADER}/notice/message/unreads`,
      unreadsnum: `${URL_HEADER}/notice/message/unreadsnum`,
      send: `${URL_HEADER}/notice/message/send`
    }
  },
  pdf: {
    create: `${URL_HEADER}/pdf/create`,
  },
  download: `${URL_HEADER}/download`,
  file: {
    download: `${URL_HEADER}/file/download`,
    gallery: {
      list: `${URL_HEADER}/file/gallery/list`,
      filterlist: `${URL_HEADER}/file/gallery/filterlist`,
      eqfilterlist: `${URL_HEADER}/file/gallery/eqfilterlist`,
      edit: `${URL_HEADER}/file/gallery/edit`,
      eqedit: `${URL_HEADER}/file/gallery/eqedit`,
      files: `${URL_HEADER}/file/gallery/files`,
      eqfiles: `${URL_HEADER}/file/gallery/eqfiles`,
      file: `${URL_HEADER}/file/gallery/file`,
      eqfile: `${URL_HEADER}/file/gallery/eqfile`,
      mainfiles: `${URL_HEADER}/file/gallery/mainfiles`,
    }
  },
  token: {
    check: `${URL_HEADER}/token/check`
  },
  fetch: {
    gallery: {
      selectfiles: `${URL_HEADER}/fetch/gallery/selectfiles`,
    },
    excel: {
      get: `${URL_HEADER}/fetch/excel/get`
    },
    file: {
      resources: `${URL_HEADER}/fetch/file/resources`,
      image: `${URL_HEADER}/fetch/file/image`,
      raw: `${URL_HEADER}/fetch/file/raw`      
    }
  },
  export: {
    container: {
      get: `${URL_HEADER}/export/container/get`
    },
    dashboard: {
      get: `${URL_HEADER}/export/dashboard/get`
    },
    datatable: {
      get: `${URL_HEADER}/export/datatable/get`
    },
    pagesvg: {
      get: `${URL_HEADER}/export/pagesvg/get`
    },
  },
  websocket: {
    messenger: `${WEBSOCKET_HEADER}/messenger`,
  },

  md2: {
    filter: {
      // system completion
      scarea: `${URL_HEADER}/service/filter/scarea`,
    },

    // system completion
    sc: {
      // Certificate of Inspection
      coiitem: `${URL_HEADER}/service/sc/coiitem`,
    }
  },
  tortue: {
    // planning
    cms: {
      leveloptions: `${URL_HEADER}/tortue/cms/leveloptions`,
    }
  }
}

export default Url
